var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[
    { or_bg: _vm.lastClass },
    { last_deps: _vm.lastClass },
    { o_depth02: !_vm.lastClass },
    { active: this.clicked },
    { meme: this.me },
  ],on:{"mousedown":_vm.Or_bg,"touchstart":_vm.Or_bg}},[_c('div',{on:{"click":_vm.onCard}},[_c('b',{class:{ on: this.isOpen },on:{"click":_vm.toggle}}),_c('span',[_vm._v(_vm._s(_vm.item.name)+" "),(this.item.kinds == 'Person')?_c('em',{staticClass:"tel"},[_vm._v(_vm._s(_vm.item.office))]):_vm._e()])]),_c('ul',{style:({ display: this.isBlock })},_vm._l((_vm.children),function(child,index){return _c('org-item',{key:index,attrs:{"item":child,"modalAutoOrg":_vm.modalAutoOrg,"createdOrg":_vm.createdOrg,"modalon":_vm.modalon},on:{"OpenFolder":_vm.OpenFolder,"OpenCard":_vm.OpenCard,"SetcreatedOrg":_vm.SetcreatedOrg}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }